module.exports = __webpack_public_path__ + "static/images/components/NavigationArrow/images/arrow-left-hover-big.05b3acd6.png";


//////////////////
// WEBPACK FOOTER
// ./components/NavigationArrow/images/arrow-left-hover-big.png
// module id = 2638
// module chunks = 11